import { render, staticRenderFns } from "./PropertyPlant.vue?vue&type=template&id=69828714&"
import script from "./PropertyPlant.vue?vue&type=script&lang=ts&"
export * from "./PropertyPlant.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports